import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EyeIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M12.964 7.414a9.77 9.77 0 0 1 8.82 5.5 9.77 9.77 0 0 1-8.82 5.5 9.77 9.77 0 0 1-8.82-5.5 9.77 9.77 0 0 1 8.82-5.5Zm0-2c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5Zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5Zm0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5Z" />
  </Icon>
);

export default memo(EyeIcon);
